import type {
    QuestionnaireMeasuresConstantType,
    QuestionnaireMeasures,
    QuestionnaireSize
} from "./type";
import type {
    ButtonSize
} from "../button/type";

export const QUESTIONNAIRE_LABEL_VARIANTS: Record<QuestionnaireSize, keyof NCoreUIKit.Typography> = {
    medium: "bodyMediumSize",
    large: "bodyLargeSize"
};

export const QUESTIONNAIRE_ROW_HEIGHTS: Record<QuestionnaireSize, keyof NCoreUIKit.ControlHeights> = {
    medium: "medium",
    large: "large"
};

export const QUESTIONNAIRE_BUTTON_SIZES: Record<QuestionnaireSize, ButtonSize> = {
    medium: "medium",
    large: "large"
};

export const QUESTIONNAIRE_FIELD_SIZES: Record<QuestionnaireSize, QuestionnaireSize> = {
    medium: "medium",
    large: "large"
};

export const getQuestionnaireMeasures = ({
    controlHeights,
    touchTargets,
    pointerType,
    typography,
    size
}: QuestionnaireMeasuresConstantType): QuestionnaireMeasures => {
    const labelVariant = QUESTIONNAIRE_LABEL_VARIANTS[size];

    const lineHeight = typography[labelVariant].lineHeight;

    const rowHeight = Math.max(controlHeights[QUESTIONNAIRE_ROW_HEIGHTS[size]], pointerType === "coarse" ? touchTargets.preferred : 0);

    return {
        labelVariant,
        lineHeight,
        rowHeight
    };
};
